// pages/karigars/KarigarList.jsx
// A panel inside KarigarsPage — the page chrome (title, ＋ Add Karigar) lives in the
// shell, so this renders the card only.
import { useEffect, useState } from "react";
import { karigarsAPI }  from "../../services/api";
import { useRouter }    from "../../contexts/RouterContext";
import { useToast }     from "../../contexts/ToastContext";
import { usePagination } from "../../hooks/usePagination";
import { Loading, Pagination, ConfirmModal, EmptyState } from "../../components/ui";
import { StatusBadge }  from "../../utils/helpers";

export default function KarigarList() {
  const { navigate }  = useRouter();
  const toast         = useToast();

  const [karigars,      setKarigars]      = useState([]);
  const [loading,       setLoading]       = useState(true);
  const [search,        setSearch]        = useState("");
  const [filterWork,    setFilterWork]    = useState("All");
  const [deleteTarget,  setDeleteTarget]  = useState(null);
  const [deleting,      setDeleting]      = useState(false);

  const load = () => {
    setLoading(true);
    karigarsAPI.list().then((d) => { setKarigars(d); setLoading(false); });
  };
  useEffect(load, []);

  const filtered = karigars.filter((k) => {
    const matchSearch =
      k.name.toLowerCase().includes(search.toLowerCase()) ||
      k.phone.includes(search) ||
      (k.speciality || "").toLowerCase().includes(search.toLowerCase());
    const matchWork = filterWork === "All" || k.workType === filterWork;
    return matchSearch && matchWork;
  });

  const { paged, page, setPage, total, count } = usePagination(filtered, 8);

  const handleDelete = async () => {
    setDeleting(true);
    await karigarsAPI.delete(deleteTarget.id);
    toast(`"${deleteTarget.name}" removed`);
    load();
    setDeleteTarget(null);
    setDeleting(false);
  };

  return (
    <>
      <div className="card">
        {/* Filters */}
        <div className="card-header">
          <div className="filter-bar" style={{ width: "100%" }}>
            <div className="search-bar" style={{ flex: 1, maxWidth: 320 }}>
              <span className="search-icon">🔍</span>
              <input
                className="form-input"
                placeholder="Search karigars…"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <div style={{ display: "flex", gap: 6 }}>
              {["All", "Pant", "Shirt", "Both"].map((w) => (
                <button
                  key={w}
                  className={`btn btn-sm${filterWork === w ? " btn-primary" : " btn-ghost"}`}
                  onClick={() => setFilterWork(w)}
                >
                  {w}
                </button>
              ))}
            </div>
            <span className="td-muted" style={{ fontSize: 12.5 }}>
              {karigars.length} worker{karigars.length !== 1 ? "s" : ""} registered
            </span>
          </div>
        </div>

        {loading ? (
          <Loading />
        ) : (
          <>
            <div className="table-wrap">
              <table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Karigar Name</th>
                    <th>Phone</th>
                    <th>Address</th>
                    <th>Work Type</th>
                    <th>Speciality</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {paged.length === 0 ? (
                    <tr>
                      <td colSpan={8}>
                        <EmptyState
                          icon="🧵"
                          title={search ? "No karigars match your search" : "No karigars yet"}
                          subtitle={!search ? "Click 'Add Karigar' to register a tailor" : undefined}
                        />
                      </td>
                    </tr>
                  ) : (
                    paged.map((k, i) => (
                      <tr key={k.id}>
                        <td className="td-muted" style={{ fontSize: 12 }}>{(page - 1) * 8 + i + 1}</td>
                        <td  style={{color: "var(--gold)" }} ><strong>{k.name}</strong></td>
                        <td className="td-muted">{k.phone}</td>
                        <td className="td-muted" style={{ maxWidth: 160, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {k.address || "—"}
                        </td>
                        <td><StatusBadge status={k.workType} /></td>
                        <td className="td-muted">{k.speciality || "—"}</td>
                        <td><StatusBadge status={k.status} /></td>
                        <td>
                          <div className="td-actions">
                            <button className="btn btn-ghost btn-sm" onClick={() => navigate("karigar-edit", { id: k.id })}>View/Edit</button>
                            {/* <button className="btn btn-danger btn-sm" onClick={() => setDeleteTarget(k)}>Delete</button> */}
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
            <Pagination page={page} total={total} setPage={setPage} count={count} perPage={8} />
          </>
        )}
      </div>

      <ConfirmModal
        open={!!deleteTarget}
        onClose={() => setDeleteTarget(null)}
        onConfirm={handleDelete}
        loading={deleting}
        title="Remove Karigar"
        message={`Remove "${deleteTarget?.name}" from the system? This cannot be undone.`}
      />
    </>
  );
}
